
import renderCategoryChips from './templates/factfinder-category-chips.tpl.html';

const EN = window.EN;
const EN_KO = window.EN_KO;

class FactfinderCategoryChips {

	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.innerEl = containerEl.querySelector( '.mdl_categeorychips__inner' );

		this.containerEl.addEventListener( 'click', ( ev ) => {
			const buttonEl = ev.target.closest( '.mdl_categeorychips__item-trigger, .mdl_categeorychips__header-back-trigger' );

			if ( buttonEl ) {
				if ( buttonEl.dataset.searchParams ) {
					const searchParams = JSON.parse( buttonEl.dataset.searchParams );
					this.containerEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams } } ) );
				}
			}
		} );
	}

	manipulateResponse( responseData ) {
		return responseData;
	}

	async update( { facets, searchParams } ) {
		this.searchParams = searchParams;

		const facet = facets.find( ( facet ) => 'CategoryPath' === facet.associatedFieldName );

		if ( facet ) {
			let recentSelectedElem = false;
			let elems = [];
			let currentLevel = 0;
			let currentLevelHeader = false;

			if ( facet.selectedElements.length ) {
				// Get the latest selected element
				recentSelectedElem = facet.selectedElements.reduce( ( prev, current ) => prev.clusterLevel > current.clusterLevel ? prev : current );

				// Set current level
				currentLevel = recentSelectedElem.clusterLevel;
			}

			// Check for root level -> output all elements
			if ( !recentSelectedElem ) {
				elems = [...facet.elements];
			} else {
				// Check if latest selected element has children
				const hasChildren = facet.elements.some( ( elem ) => elem.clusterLevel === currentLevel + 1 );

				// Get all child elements of latest selected element or sibling elements
				elems = facet.elements.filter( ( elem ) => elem.clusterLevel === currentLevel + ( hasChildren ? 1 : 0 ) );

				// Get the parent element of current selected element
				const parentElem = facet.selectedElements.filter( ( elem ) => elem.clusterLevel === recentSelectedElem.clusterLevel - ( hasChildren ? 0 : 1 ) ).pop();

				let backSearchParams = false;

				// Get all selected elements which have selected = 'TRUE'
				const realSelectedElement = facet.selectedElements.filter( ( elem ) => elem.selected === 'TRUE' );

				if( realSelectedElement.length ) {
					// Check if parent element is implicit selected, if yes filter for really selected elem and use the search params of last in array, if no use the search params of parent element
					backSearchParams = parentElem.selected === 'IMPLICIT' ? realSelectedElement.pop()?.searchParams : parentElem.searchParams;
				}

				currentLevelHeader = {
					'title': parentElem.text,
					'totalHits': parentElem.totalHits,
					'searchParams': backSearchParams
				};

				// Add latest selected element if it has no children
				if ( !hasChildren ) {
					elems = [
						recentSelectedElem,
						...elems
					];
				}
			}

			elems.sort( ( a, b ) => {
				if( a.selected === 'TRUE' || a.selected === 'IMPLICIT' ) return -1;
				if( b.selected === 'TRUE' || a.selected === 'IMPLICIT' ) return 1;
				return a.text.localeCompare( b.text )
			} );

			// Render output of category chips
			EN.Render.render( 'factfinder-category-chips', { currentLevelHeader, elems } ).then( ( renderedHTML ) => {
				this.innerEl.innerHTML = renderedHTML;
			} );
		}
	}
}

EN.Render.addTemplate( 'factfinder-category-chips', renderCategoryChips );

export default FactfinderCategoryChips;
